export default __webpack_public_path__ + "static/media/stream_line.b34d3850.png";